import { useGrid, UseGridReturnType } from "common";
import { createContext, useEffect, useState } from "react";
import {
  getSubmitLimit,
  getSubmitService,
  SubmitFormItem,
  SubmitListItem,
} from "./submitApi";

export type UseSubmitListReturnType = {
  grid: UseGridReturnType;
  submitLimit: number;
  submitCount: number;
};

export const SubmitListContext = createContext<UseSubmitListReturnType>(
  {} as UseSubmitListReturnType
);

export default function useSubmitList({
  waiver_id,
}: {
  waiver_id?: any;
}): UseSubmitListReturnType {
  const service = getSubmitService();
  const grid = useGrid<SubmitFormItem, SubmitListItem>({
    comaSeparatedSortPrarms: true,
    storageType: waiver_id ? "none" : "urlParams",
    id: "Submits",
    loadColumns: true,
    translationCategory: "Submit",
    defaultFilter: waiver_id
      ? {
          waiver_id: waiver_id,
        }
      : undefined,
    exportFilter: filter => ({
      SubmitSearch: filter,
    }),
    ...service,
  });
  const [submitLimit, setSubmitLimit] = useState(0);
  const [submitCount, setSubmitCount] = useState(0);

  useEffect(() => {
    updateSubmitLimit();
  }, []);

  async function updateSubmitLimit() {
    const result = await getSubmitLimit();

    if (result?.data?.data) {
      const resultLimit = result.data.data?.limit;
      const resultCount = result.data.data?.count;
      setSubmitLimit(resultLimit);
      setSubmitCount(resultCount);
    }
  }

  return {
    grid,
    submitLimit,
    submitCount,
  };
}
